import PropTypes from 'prop-types';
import React from 'react';

class WebHotelListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selected: props.hotel.selected }
    this.handleChange = this.handleChange.bind(this);
    this.handleFavorite = this.handleFavorite.bind(this);
    this.handleDisplay = this.handleDisplay.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hotel.selected !== this.props.hotel.selected) {
      this.setState({
        selected: nextProps.hotel.selected
      })
    }
  }

  handleChange(e) {
      e.preventDefault();
      const bidData =this.props.event.event.bids.bid_details
    let counter =0
    for(let i=0;i<bidData.length;i++){
      if(bidData[i].check_in_date !== null){
        counter+=1
      }
    }
    if (counter<=0){
      this.props.displayError()
    }
      // if (this.props.event.event.bids.bid_details.filter(o => o.group_id == this.props.groupId && o.event_id == this.props.event.event.id).length) {
      //   this.props.displayError()
      // }
      else{
          this.setState(prevState => ({
            selected: !prevState.selected,
          }));
          this.props.selectHotel({ hotel: this.props.hotel, selected: !this.state.selected, tourgroup_id: this.props.groupId });
      }
  }
  handleFavorite(e) {
    e.preventDefault();
    this.setState(prevState => ({
      favorite: !prevState.favorite,
    }));
    this.props.favoriteHotel(this.props.hotel.id, !this.state.favorite);
  }
  handleDisplay(e) {
    e.preventDefault();
    this.props.displayHotel(this.props.hotel.id);
  }

  render() {
    const color = this.props.hotel.management ? 'green' : '';
    return (
      <li
        style={{
          color,
          borderBottom: '1px solid #f0f0f0',
          paddingTop: 10,
          paddingBottom: 10,
        }}
      >
        <div className="hotel-name">
          <input
            id={this.props.hotel.place_id}
            type="checkbox"
            onChange={this.handleChange}
            checked={this.state.selected}
          />
          <span className="pointer-hover" onClick={this.handleDisplay} role="presentation">
            <span>
              {this.props.hotel.name}&nbsp;
            </span>
          </span>
          <div>
            <div className="hotel-distance">
              {this.props.hotel.rating ? this.props.hotel.rating : <span>Not available</span>}{' '}
              <span className="fa fa-star" />
               <span>
                ({parseFloat(this.props.hotel.distance * 0.621371).toFixed(2)} mi. from venue)
              </span>
            </div>
          </div>
        </div>
        <div className="hotel-details text-muted">
          <p>
            <i className="fa fa-map-marker" />
            {this.props.hotel.formatted_address}, &nbsp;
          </p>
        </div>
      </li>
    );
  }
}

WebHotelListItem.propTypes = {
  hotel: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    formatted_address: PropTypes.string,
    selected: PropTypes.bool.isRequired,
  })
};
WebHotelListItem.defaultProps = {
  hotel: {
    selected: false,
  },
};
export default WebHotelListItem;


// WEBPACK FOOTER //
// src/routes/tours/components/WebHotelListItem.js